import type { ReactElement } from 'react'
import { GameCard } from '../components/GameCard'
import { GAMES } from '../registry'

/** 游戏大厅：内容全部来自注册表，除注册表外没有任何游戏专属代码 */
export function LobbyView(): ReactElement {
  return (
    <div className="min-h-0 flex-1 overflow-y-auto">
      <div className="mx-auto w-full max-w-5xl px-3 pb-6 sm:px-4">
        <details open className="mt-4 rounded-xl border border-white/10 bg-white/5 px-4 py-3">
          <summary className="cursor-pointer text-[1.3rem] font-semibold">平台说明</summary>
          <p className="mt-2 text-sm text-white/60">
            这里是小游戏集合。每个游戏有自己的页面（例如战争迷雾象棋在 <code>/fogchess</code>），
            进入后可以创建对局并把房间链接发给朋友，也可以输入房间号加入对局。
          </p>
        </details>

        <h1 className="mt-6 text-xl font-semibold">游戏大厅</h1>
        <p className="mt-1 text-sm text-white/60">选择一个游戏，进入后可以创建对局或加入对局。</p>

        <div className="mt-4 grid gap-4 sm:grid-cols-2">
          {GAMES.map((entry) => (
            <GameCard
              key={entry.id}
              name={entry.name}
              description={entry.description}
              to={entry.path}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
